import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {Helper} from '../../helpers/helper.service';
import {LanguageListResponse, LanguageResponse} from '../translation.models';
import { map } from 'rxjs/operators';
import { catchError } from 'rxjs/operators';

@Injectable()
export class LanguageService {
  /**
   * @param {Helper} helper
   * @param {HttpClient} http
   */
  constructor(private helper: Helper, private http: HttpClient) {
  }

  /**
   * List Languages
   *
   * @returns {Observable<LanguageListResponse>}
   * @param {HttpParams} params
   */
  list(
    params = new HttpParams,
  ): Observable<LanguageListResponse> {
    const url = `${environment.apiUrl}/translation/language/`;
    return this.http.get<LanguageListResponse>(
      url,
      {params: params}
    );
  }

  /**
   * update localization
   */
  purgeTranslations() {
    return this.http.delete<LanguageResponse>(
      `${environment.apiUrl}/translation/translation/purge`
    );
  }

  /**
   * Find a language by locale
   *
   * @param {string} locale
   * @returns {Observable<LanguageResponse>}
   */
  getByLocale(locale: string): Observable<LanguageResponse> {
    return this.http.get<LanguageResponse>(
      `${environment.apiUrl}/translation/language/${locale}`
    );
  }

  /**
   * Manage Language
   * @param language
   * @param isEdit
   * @param id
   */
  public manageLanguage(language, isEdit, id = null) {
    if (isEdit) {
      return this.http.put(environment.apiUrl + '/translation/language/' + id, language)
        .pipe(catchError(res => this.helper.catchError(res)));
    }
    return this.http.post(environment.apiUrl + '/translation/language/ ', language)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  /**
   * Get a language by it's id.
   */
  getLanguageById(id) {
    return this.http.get<LanguageResponse>(
      `${environment.apiUrl}/translation/language/` + id
    );
  }

  public getLanguageReplace(gridData = new HttpParams()) {
    return this.http.get<any>(environment.apiUrl + '/translation/language/?' + gridData.toString())
      .pipe(map(rsp => rsp['languages']), catchError(res => this.helper.catchError(res)));
  }

  public replaceLanguage(id, newLanguageId) {
    return this.http.put(
      `${environment.apiUrl}/localization/replace/` + id, {language: newLanguageId})
      .pipe(catchError(res => this.helper.catchError(res)));
  }
}
